<template>
  <div class="comments-ctn">
    <div class="section-header">
      <img src="../assets/header_green.png" />
      <p class="section-title">
        推荐{{ type === 'article' ? '文章' : '视频' }}
      </p>
    </div>
    <div
      class="recommendation-ctn"
      v-for="(recommendation, index) in recommendations"
      :key="index"
      @click="onRecommendation(recommendation)"
    >
      <div class="recommendation-info">
        <p class="recommendation-title">{{ recommendation.title }}</p>
        <div class="recommendation-bottom">
          <img class="time-icon" src="../assets/home_item_time.png" />
          <span class="rec-time-count">{{
            moment(recommendation.createdAt).format('YYYY-MM-DD')
          }}</span>
          <img class="time-icon last-icon" src="../assets/home_item_view.png" />
          <span class="rec-time-count">
            {{ recommendation.read_times || 100 }}
          </span>
        </div>
      </div>
      <img mode="widthFix" class="cover" :src="recommendation.cover_url_2" />
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Recommendation',
  props: {
    recommendations: Array,
    onRecommendation: Function,
    type: String,
  },
  methods: {
    moment: moment,
  },
};
</script>

<style scoped>
.comments-ctn {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  padding: 10px;
  font-family: sans-serif;
  box-sizing: border-box;
  background-color: #f7f7f7;
}

p {
  margin: 0;
  padding: 0;
}

.section-header {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.section-header img {
  width: 8px;
  height: 24px;
  margin-right: 4px;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  padding: 10px 0;
  color: #333;
}

.recommendation-ctn {
  display: flex;
  width: 100%;
  padding: 10px;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  border-bottom-color: #f5f5f5;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  background-color: #fff;
  margin-top: 5px;
  border-radius: 5px;
}

.recommendation-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  height: 80px;
  flex: 1;
  text-align: justify;
  margin-right: 10px;
  font-size: 14px;
}

.recommendation-title {
  font-size: 16px;
  color: #333;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}

.recommendation-bottom {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.time-icon {
  width: 15px;
  height: 15px;
  margin-right: 4px;
  object-fit: contain;
}

.last-icon {
  margin-left: 10px;
}

.cover {
  width: 84px;
  height: 84px;
  object-fit: cover;
  border-radius: 4px;
}

.rec-time-count {
  font-size: 12px;
  color: #666;
}
</style>
